// src/components/monthly/RoomTypeCard.tsx
import React from 'react';
import Picture from '@/image/hotel/picture9.png';

interface RoomTypeCardProps {
  // 物件名（日本語版）と英語版（オプション）
  propertyName: string;
  propertyName_en?: string;
  // 部屋タイプ（日本語版）と英語版（オプション）
  roomType: string;
  roomType_en?: string;
  // 画像URL（変更なし）
  imageUrl: string;
  // 説明文（日本語版）と英語版（オプション）
  description: string;
  description_en?: string;
  // エリア名（日本語版）と英語版（オプション）
  area: string;
  area_en?: string;
  roomArea?: string;
  // 収容人数（ここはそのまま）
  capacity: string;
  // 言語判定フラグ。true の場合は英語表示、false は日本語表示
  useEnglish: boolean;
}

export const RoomTypeCard: React.FC<RoomTypeCardProps> = ({
  propertyName,
  propertyName_en,
  roomType,
  roomType_en,
  imageUrl,
  description,
  description_en,
  area,
  area_en,
  capacity,
  useEnglish,
  roomArea,
}) => {
  return (
    <div>
      <p className="text-[13px] mb-2">
        Selected Room Type:
        {/* {useEnglish ? 'Selected Room Type:' : '選択された部屋タイプ:'} */}
      </p>
      <div className="border border-black p-4 flex flex-col md:flex-row">
        {/* 左側（画像） */}
        <div className="flex justify-center md:justify-end">
          <img
            src={imageUrl}
            alt={useEnglish && propertyName_en ? propertyName_en : propertyName}
            className="w-full h-auto md:max-w-[223px]"
            // 画像読み込み失敗時にダミー画像へ切り替え
            onError={(e) => {
              e.currentTarget.src = Picture;
            }}
          />
        </div>
        {/* 右側（テキスト群） */}
        <div className="md:w-1/2 md:pl-4">
          <p className="text-xl text-gray-700 underline mt-3">
            {useEnglish && propertyName_en ? propertyName_en : propertyName}
          </p>
          <p className="text-sm">
            {useEnglish && roomType_en ? roomType_en : roomType}
          </p>
          <p className="text-xs mt-5">
            {useEnglish ? 'Area:' : '広さ:'}
            {roomArea
              ? (Math.floor(parseFloat(roomArea) * 10) / 10).toFixed(1)
              : '-'}
            ㎡
          </p>
          <p className="text-xs mb-5">
            {useEnglish ? 'Capacity:' : '宿泊人数:'} {capacity}
          </p>
          {/* 追加説明 */}
          {description && (
            <div>
              <p className="text-[11px] text-gray-700 mt-2">
                {useEnglish ? 'Info:' : '設備:'}
              </p>
              <p className="text-[11px] text-gray-700">
                {useEnglish && description_en ? description_en : description}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
